export default __webpack_public_path__ + "static/media/shalat.4efeb65e.png";